export default __webpack_public_path__ + "static/media/artistSwipper.8c5ffa7f.jpg";